module.exports = __webpack_public_path__ + "static/media/unknown.428f2a80.svg";